import './styles.scss';


//Type: green/outline
const Label = ({ text, type = "green" }) => {
    return <div className={`label label--${type}`}>{text}</div>;
}

export default Label;
